import { useTranslation } from "react-i18next";
import ExploreOtherOptions from "../../components/ExploreOtherOptions";
import { BookingBox } from "../../components/booking-card/BookingBox";
import UiSection from "../../components/box/UiSection";
import Tabs from "../../components/detail/Tabs";
import { ProdAttrPicker } from "../../components/prodattr-picker/ProdAttrPicker";
import { ProductBanner } from "../../components/product-detail/ProductBanner";
import { ProductInformation } from "../../components/product-detail/ProductInformation";
import { ProductMoreInfo } from "../../components/product-detail/ProductMoreInfo";
import { useUiVersion } from "../../hooks/useUiVersion";
import { ProdAttrUtils } from "../../utils/productAttributeUtils";
import BookingCardBottom from "../booking-card/BookingCardBottom";
import ProductInfoHeader from "./ProductInfoHeader";
import { ProductMap } from "./ProductMap";
import { useProductDetailPage } from "./useProductDetailPage";
import LoadingCard from "../LoadingCard";
import { Helmet } from "react-helmet-async";

export const ProductDetailPage = () => {
  const { uiVersion } = useUiVersion();
  return <ProductDetailPageContent key={uiVersion} />;
};
export const ProductDetailPageContent = () => {
  const { t } = useTranslation();
  const { productData, isError } = useProductDetailPage();
  if (isError) {
    return <div>Error fetching data</div>;
  }

  const tabs = [
    t("Information2"),
    t("Select Option"),
    productData?.scheduleImg ? t("Schedule") : "",
    !!ProdAttrUtils.TOUR.extractHighlight(productData?.attributeList).length
      ? t("Highlights")
      : "",
    productData?.locationInstruction ? t("Location Instruction") : "",
    productData?.operatingInfo ? t("Operating Info") : "",
    productData?.howToUse ? t("How to Use") : "",
    productData?.noteContent ? t("Notes") : "",
  ].filter((tab) => tab);

  const productSchema = productData
    ? {
        "@context": "https://schema.org",
        "@type": "Product",
        name: productData.name,
        image: productData.thumbnail,
        // description:
        //   "뉴욕 엠파이어 스테이트 빌딩 입장권. 모바일 바우처로 간편하게 입장하세요.",
        brand: {
          "@type": "Brand",
          name: "Tamice",
        },
        offers: {
          "@type": "Offer",
          priceCurrency: "USD",
          price: `${productData.price}`,
          itemCondition: "https://schema.org/NewCondition",
          availability: "https://schema.org/InStock", //  OutOfStock - PreOrder  -  Discontinued
          url: window.location.href,
          validFrom: "2025-08-01T00:00:00+09:00",
        },
      }
    : null;

  return (
    <>
      <Helmet>
        {productData && (
          <script type="application/ld+json">
            {JSON.stringify(productSchema)}
          </script>
        )}
      </Helmet>
      <div className="relative">
        {/* <BreadcrumbNavigation ls={["Ticket", productData?.cityName]} /> */}
        <ProductBanner d={productData} />

        {productData ? (
          <>
            <div className="ui-container relative mt-[3.1044rem]">
              <ProductInfoHeader d={productData} />
              <div className="flex gap-[2rem]">
                <div className="pd-left">
                  <Tabs tabs={tabs} />
                  <ProductInformation d={productData} />
                  <UiSection title={t("Select Option")} className="pb-0" />
                  <ProdAttrPicker d={productData} mode="FORM" />
                  <ProductMoreInfo d={productData} />
                </div>
                <div className="flex flex-col gap-2.5">
                  <div className="hidden sm:block">
                    <ProductMap d={productData} />
                  </div>
                  <BookingBox />
                </div>
              </div>
              {productData && (
                <ExploreOtherOptions
                  id={productData.id}
                  productType={productData.productType}
                />
              )}
            </div>
          </>
        ) : (
          <LoadingCard rows={2} />
        )}
        <BookingCardBottom />
      </div>
    </>
  );
};
